import { render, staticRenderFns } from "./BriqueChartModal.vue?vue&type=template&id=3f35b48f&"
import script from "./BriqueChartModal.js?vue&type=script&lang=js&"
export * from "./BriqueChartModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports